import { useResourceScheduling } from '@/features/resources/booking';
import { RoomsAxisToggle } from '@/features/resources/calendar';

import { MobileBookingsHeader } from './mobile-bookings-header';

import type { TCalendarView } from '@/components/calendar/types';

interface MobileTeamHeaderProps {
  view: TCalendarView;
  basePath: string;
}

/**
 * Mobile header for the TEAM axis.
 *
 * The desktop header renders the Team ⇄ Rooms switch, but phones get
 * `MobileBookingsHeader` instead, which had none: the room calendar was
 * reachable on a phone only by typing its URL. This mirrors
 * `MobileRoomsHeader`'s strip so the switch sits in the same place on both
 * axes. Shown only once the org has a room, like `StaffAxisToggleSlot`.
 */
export function MobileTeamHeader({ view, basePath }: MobileTeamHeaderProps) {
  const { enabled } = useResourceScheduling();
  return (
    <>
      <MobileBookingsHeader view={view} basePath={basePath} />
      {enabled ? (
        <div className="flex items-center gap-2 border-b bg-background px-3 py-2">
          <RoomsAxisToggle axis="team" />
        </div>
      ) : null}
    </>
  );
}
